import { SelectOptionType } from "../models/GlobalModels";

export const Constants = {
  APP_NAME: "Kshema CCE",

  // IS_USER_LOGED_IN: 'isUserLogedIn',
  AUTHENTICATION_DATUM: "authenticationDatum",
  // USER_MOBILE_NUMBER: 'userMobileNumber',
};

export const DEFAULT_OPTION: SelectOptionType = {
  label: "Select",
  value: null,
};

export const SIDE_MENU_STATUS = {
  OPEN: 1,
  CLOSE: 2,
  OPPOSITE: 3,
};

export const LIST_VIEW_ITEM = {
  LIST_ITEMS: "list-items",
  VIEW_ITEM: "view-item",
};

export const STORAGE_KEY = {
  AUTH_DATA: "chm-app-auth",
  ITUS: "chm-app-itus",
  SSOT: "fa-sso-token",
};

export const API_RESPONSE_CODE = {
  FAIL: "1",
  SUCCESS: "0",
};

export const LOGIN_STATUS = {
  INITIATED: "initiated",
  AUTHENTICATED: "authenticated",
  NO_AUTHENTICATED: "no-authenticated",
};

export const ICV_STATUS = {
  ASSIGNED: 1,
  COMPLETED: 2,
  QC_PENDING: 3,
  QC_IN_PROGRESS: 4,
  REASSIGNED: 5,
  ON_HOLD: 6,
};

export const CROP_SOWN_OPTIONS = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

export const IMAGE_QUALITY_OPTIONS = [
  { value: "acceptable", label: "Acceptable" },
  { value: "nonAcceptable", label: "Non Acceptable" },
];
export const ON_HOLD_OPTIONS = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];
export const ASSIGN_QC_ACTIONS = {
  ASSIGN: 1,
  REASSIGN: 2,
};

export const PAGINATION_OPTIONS = {
  ICV_ACTIVITIES: ["250", "500", "1000", "2500"],
  COMPLETED_ICV: ["250", "500", "1000", "2500"],
  DEFAULT: ["25", "50", "100"],
};

export const bankOptions = [
  { label: "State Bank of India", value: "State Bank of India" },
  { label: "HDFC Bank", value: "HDFC Bank" },
  { label: "ICICI Bank", value: "ICICI Bank" },
  { label: "Axis Bank", value: "Axis Bank" },
  { label: "Punjab National Bank", value: "Punjab National Bank" },
  { label: "Bank of Baroda", value: "Bank of Baroda" },
  { label: "Canara Bank", value: "Canara Bank" },
  { label: "Union Bank of India", value: "Union Bank of India" },
  { label: "Bank of India", value: "Bank of India" },
  { label: "Indian Bank", value: "Indian Bank" },
  { label: "Central Bank of India", value: "Central Bank of India" },
  { label: "Indian Overseas Bank", value: "Indian Overseas Bank" },
  { label: "UCO Bank", value: "UCO Bank" },
  { label: "Yes Bank", value: "Yes Bank" },
  { label: "Kotak Mahindra Bank", value: "Kotak Mahindra Bank" },
  { label: "IDFC First Bank", value: "IDFC First Bank" },
  { label: "IDBI Bank", value: "IDBI Bank" },
  { label: "Bandhan Bank", value: "Bandhan Bank" },
  { label: "RBL Bank", value: "RBL Bank" },
  { label: "IndusInd Bank", value: "IndusInd Bank" },
  { label: "City Union Bank", value: "City Union Bank" },
  { label: "Tamilnad Mercantile Bank", value: "Tamilnad Mercantile Bank" },
  { label: "Karur Vysya Bank", value: "Karur Vysya Bank" },
  { label: "Lakshmi Vilas Bank", value: "Lakshmi Vilas Bank" },
  { label: "AU Small Finance Bank", value: "AU Small Finance Bank" },
  {
    label: "Rajasthan Marudhara Gramin Bank",
    value: "Rajasthan Marudhara Gramin Bank",
  },
  { label: "Equitas Small Finance Bank", value: "Equitas Small Finance Bank" },
  { label: "Ujjivan Small Finance Bank", value: "Ujjivan Small Finance Bank" },
];

export const vendorResponse = {
  data: [
    {
      vendorId: "VND0001",
      vendorName: "Sri Lakshmi Agro Traders",
      emailId: "contact@srilakshmiagro.com",
      mobileNumber: "9876543210",
      status: "Active",
      state: "TELANGANA",
      district: "Rangareddy",
      blockMandal: "Shamshabad",
    },
    {
      vendorId: "VND0002",
      vendorName: "Green Field Supplies",
      emailId: "support@greenfieldsupplies.in",
      mobileNumber: "9867452311",
      status: "Inactive",
      state: "ANDHRA PRADESH",
      district: "Guntur",
      blockMandal: "Tadikonda",
    },
    {
      vendorId: "VND0003",
      vendorName: "Krishna Seeds Corporation",
      emailId: "info@krishnaseeds.com",
      mobileNumber: "9887766554",
      status: "Active",
      state: "TELANGANA",
      district: "Medchal",
      blockMandal: "Kompally",
    },
    {
      vendorId: "VND0004",
      vendorName: "Ravi Fertilizers",
      emailId: "ravifertilizers@gmail.com",
      mobileNumber: "9845123678",
      status: "Active",
      state: "KARNATAKA",
      district: "Raichur",
      blockMandal: "Manvi",
    },
    {
      vendorId: "VND0005",
      vendorName: "Annapurna Agro Agency",
      emailId: "annapurna.agro@rediffmail.com",
      mobileNumber: "9812233445",
      status: "Inactive",
      state: "MAHARASHTRA",
      district: "Nanded",
      blockMandal: "Mukhed",
    },
    {
      vendorId: "VND0006",
      vendorName: "Sai Pesticides",
      emailId: "sales@saipesticides.in",
      mobileNumber: "9898989898",
      status: "Active",
      state: "TELANGANA",
      district: "Karimnagar",
      blockMandal: "Huzurabad",
    },
    {
      vendorId: "VND0007",
      vendorName: "Vijaya Agro Solutions",
      emailId: "contact@vijayaagro.com",
      mobileNumber: "9701234567",
      status: "Active",
      state: "ANDHRA PRADESH",
      district: "Kurnool",
      blockMandal: "Nandyal",
    },
    {
      vendorId: "VND0008",
      vendorName: "Balaji Farm Inputs",
      emailId: "balajifarminputs@gmail.com",
      mobileNumber: "9911223344",
      status: "Inactive",
      state: "TELANGANA",
      district: "Warangal",
      blockMandal: "Parkal",
    },
    {
      vendorId: "VND0009",
      vendorName: "Maha Lakshmi Traders",
      emailId: "mahalakshmi.traders@yahoo.com",
      mobileNumber: "9998877665",
      status: "Active",
      state: "ODISHA",
      district: "Ganjam",
      blockMandal: "Chhatrapur",
    },
    {
      vendorId: "VND0010",
      vendorName: "Kisan Mitra Enterprises",
      emailId: "kisanmitra@enterprise.in",
      mobileNumber: "9734567812",
      status: "Active",
      state: "MADHYA PRADESH",
      district: "Indore",
      blockMandal: "Sanwer",
    },
    {
      vendorId: "VND0011",
      vendorName: "Nature Grow Agro",
      emailId: "care@naturegrowagro.com",
      mobileNumber: "9823456710",
      status: "Inactive",
      state: "CHHATTISGARH",
      district: "Raipur",
      blockMandal: "Abhanpur",
    },
    {
      vendorId: "VND0012",
      vendorName: "Ever Green Seeds",
      emailId: "support@evergreenseeds.in",
      mobileNumber: "9888123456",
      status: "Active",
      state: "PUNJAB",
      district: "Ludhiana",
      blockMandal: "Jagraon",
    },
    {
      vendorId: "VND0013",
      vendorName: "Sustainable Agro Mart",
      emailId: "info@sustainableagro.in",
      mobileNumber: "9753124680",
      status: "Active",
      state: "TAMIL NADU",
      district: "Salem",
      blockMandal: "Attur",
    },
    {
      vendorId: "VND0014",
      vendorName: "Kaveri Agri Solutions",
      emailId: "kaveri.agri@gmail.com",
      mobileNumber: "9815672345",
      status: "Inactive",
      state: "TELANGANA",
      district: "Nalgonda",
      blockMandal: "Miryalaguda",
    },
    {
      vendorId: "VND0015",
      vendorName: "Rythu Bharosa Kendra",
      emailId: "rbk.support@gov.in",
      mobileNumber: "9000012345",
      status: "Active",
      state: "ANDHRA PRADESH",
      district: "Anantapur",
      blockMandal: "Gooty",
    },
  ],
  statusMessage: "Vendor Data Fetch Successfully",
  statusCode: 1,
};
